const algorithmCapacity = 3;
export { algorithmCapacity };
